// import { Toast } from 'vant'

/**
 * AI 开放平台文档中心 https://ai-doc.unisound.com/sacalleval/http.html
 * mode 参数类型
 * 评测模式（包含A B C D E G H，A B G H 是常用模式
 * 英文支持的模式
 * A：最简单模式，结果只有单词打分没有音素信息
 * B：有音素信息，但是没有音素打分
 * C：跟A一样，同时适用于篇章打分
 * D：在B的基础上，有音素打分
 * E：返回words字段里的值，有空格和标点符号，也包含音素打分
 * G：跟D一样
 * H：选择题打分模式
 * 中文支持的模式：
 * E：返回words字段里的值，支持声母、韵母和声调的输出
 */
const Log = console.log.bind(document)

const EvalSDK = window.EvalSDK
class YZSRecorder extends EvalSDK {
  constructor(opthion) {
    const {
      userId,
      scoreCoefficient,
      mode,
      host,
      hostCn,
      useFlash,
      useSelfAudio,
      audioFormat,
      autoStop
    } = opthion || {}
    const port = location.protocol === 'https:' ? 443 : 80
    super({
      userId: userId || 'userId', // 用戶id
      scoreCoefficient: scoreCoefficient || 1.5, // 打分系数
      mode: mode || 'E', // A | B | C | D | E | H |G
      host: host || 'edu.hivoice.cn', // 服务地址
      port: port, // 服务地址端口
      hostCn: hostCn || 'cn-edu.hivoice.cn', // 中文服务地址
      portCn: port, // 中文服务地址端口
      useFlash: useFlash || false, // 使用flash
      useSelfAudio: useSelfAudio || false, // 上传本地文件
      audioFormat: audioFormat || 'opus', // opus | mp3 | amrnb
      autoStop: autoStop || 0, // 自动停止录音
      secret: '', // 密钥
      debug: true
    })
    this.duration = 0
    this.language = 'en' // cn | en
    const context = new (window.AudioContext || window.webkitAudioContext)()
    this.inputSampleRate = context.sampleRate
    this.recordMode = ''
    this.if_force = false
    this.if_begin = false

    // eslint-disable-next-line consistent-this
    const T = this

    this.onReady = function() {
      Log('录音准备成功')
    }
    this.onError = function(err) {
      // alert('启动失败')
      Log('录音准备失败', err)
    }
    this.onResult = function(result) {
      if (this.if_force) {
        return false
      }
      console.log(T.recordMode)
      Log('评测原始结果', result)
      // lines 数据是存在多行结果的，按照现有结构整合成一条数据
      const { lines, score } = result
      const integrationWords = []
      let accuracy = ''
      let fluency = {}
      let integrity = ''
      let sample = '' // 识别的原始文本 换行的整合成一行了
      lines.forEach(line => {
        sample += line.sample
        const { words } = line
        accuracy = line.pronunciation
        fluency = {
          overall: line.fluency,
          speed: line.speeding
        }
        integrity = line.integrity
        words.forEach(word => {
          // type==2 正常词
          if (word.type !== 7) {
            integrationWords.push(word)
          }
        })
      })
      // 转化详情
      const wordsDetails = integrationWords.map(m => {
        return {
          [this.language === 'cn' ? 'cn_word' : 'word']: m.text,
          score: Math.floor(m.score * 10) // 当前中文的得分
        }
      })
      const processingResults = {
        duration: this.duration.toFixed(3),
        audioUrl: this.getSoundUrl(),
        overall: Math.round(score),
        resultStr: sample,
        wordInfosArr: wordsDetails,
        accuracy: accuracy,
        fluency: fluency,
        integrity: integrity
      }
      // 中文结果 // 英文结果
      this.recorderOnResult(JSON.stringify(processingResults), result)
    }
    this.onPCM = function(pcm) {
      T.duration += 4096 / T.inputSampleRate
      const volume = Math.round(Math.max.apply(null, pcm) * 100)
      T.onVolumeMonitor(volume)
    }
    // Log(this)
  }
  startRecord(text, mode, language) {
    this.if_force = false
    this.if_begin = true
    this.duration = 0
    this.language = language || this.language
    this.recordMode = mode
    this.start(text, mode, language)
  }
  stopRecord(if_force = false) {
    if (!if_force) {
      // Toast.loading({
      //   // message: '评测中...',
      //   message: '...',
      //   forbidClick: true
      // })
      this.stop()
      // .then(res => {
      //   Toast.clear()
      // })
      // .catch(() => {
      //   Toast.clear()
      // })
    } else {
      this.if_force = true
      if (this.if_begin) {
        this.if_begin = false
        this.stop()
      }
    }
  }
  cancelRecord() {
    this.cancel()
  }
  recorderOnResult(result) {
    Log('YZSRecorder 处理后的结果', result)
  }

  onVolumeMonitor(volume) {
    Log('YZSRecorder 声音大小', volume)
  }
}
export default YZSRecorder
